import { Menu } from "lucide-react";
import SwipeToDeleteItem from "./SwipeToDeleteItem";
import { Icons } from "../assets/icons/Icons";

const AddressItem = ({ address, onDelete }) => {
    return (
        <SwipeToDeleteItem
            id={address.id}
            label={address.tag}
            onDelete={onDelete}
            rightContent="Delete"
            rightContentClassName="bg-danger"
        >
            <div
                className="rounded-3 p-3 w-100 d-flex justify-content-between align-items-center"
                style={{
                    background: "rgba(20, 20, 20, 1)",
                }}
            >
                <div className="text-truncate pe-2">{address.address}</div>
                <Icons.CryptoSlideIcon />
            </div>
        </SwipeToDeleteItem>
    );
};

export default AddressItem;
